export default __webpack_public_path__ + "static/pudgy-5233f36f5ede8e7c4602c8857ef39434.jpeg";